// extracted by mini-css-extract-plugin
export var controls = "styles-module--controls--2XEKc";
export var pad = "styles-module--pad--kl10e";
export var time = "styles-module--time--1c7tv";
export var padWrapper = "styles-module--padWrapper--NVFqH";
export var fadeInFromNone = "styles-module--fadeInFromNone--1IyDM";
export var padShadow = "styles-module--padShadow--2bKon";
export var label = "styles-module--label--1aNU3";